module.exports = __webpack_public_path__ + "img/monitor-waiting.63b62d10.svg";